import React, { Fragment } from 'react';
import spinner from './spinner.gif';

export default ({ className }) => (
  <Fragment>
    <img
      src={spinner}
      className={className}
      style={{ width: '200px', margin: 'auto', display: 'block' }}
      alt='Loading...'
    />
  </Fragment>
);
